export const formatExternalAddressText = (address) => {
  const { Line1, Line2, City, State, Zip } = address || {
    Line1: '',
    Line2: '',
    City: '',
    State: '',
    Zip: '',
  };

  return `${Line1}${Line2 ? ` #${Line2}` : ''}, ${City}, ${State} ${Zip}`;
};

export const formatExternalOfferAddress = (data) => {
  if (data?.value?.PropertyTransaction?.Property?.Address) {
    return formatExternalAddressText(data?.value?.PropertyTransaction?.Property?.Address);
  }

  return '';
};

export const getHeaderAddress = (transactionData) => {
  if (transactionData) {
    const { transactionLineOne, transactionLineTwo } = transactionData;

    return `${transactionLineOne}${transactionLineTwo ? ` #${transactionLineTwo}` : ''}`;
  }
  return '';
};
